
	import { defineComponent } from 'vue';

	import FiscalYearReportByProgram from '@/ChildrenComponents/Reports/FiscalYearReportByProgram.vue';

	import { IProgramTerminationReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';

    import { ReportService } from '@/Services/Report/report-service';

	export default defineComponent({
		name: 'program-served-report',
		components: { FiscalYearReportByProgram },
		data () {
			return {
				reportData: [] as IProgramTerminationReport[],
				isSearching: false,
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				ReportService.getProgramTerminationReportData(searchDto).then(response => this.reportData = response).finally(() => this.isSearching = false);
			}
		},
	});
